import styled from 'styled-components';
import ICON_CUSTOMS from '@/assets/korUploadFile/icon_customs.png';
import { Button, Icon } from '@successmode-ktp/kui';

type Props = {
  onClick: () => void;
};

const AnnounceText = ({ onClick }: Props) => {
  return (
    <Wrapper>
      <ExplainWrapper>
        <ContentsWrapper>
          <img src={ICON_CUSTOMS} alt='' width={24} />
          출입국사실증명서 업로드는 재외국민 택스리펀 조건을 확인하기 위한
          절차입니다.
        </ContentsWrapper>
      </ExplainWrapper>
      <ExplainWrapper>
        <ContentsWrapper>
          <div>
            <Icon.QuestionFilled size={24} fillColor='#CCCCCC' />
          </div>
          <Text>
            출입국사실증명서를 발급받지 못하는 경우 대체할 자료들을 업로드
            해주세요.
          </Text>
        </ContentsWrapper>
        <Button type='button' size='sm' theme='mono' onClick={onClick}>
          대체서류 보기
          <Icon.ChevronDown size={16} style={{ marginLeft: '8px' }} />
        </Button>
      </ExplainWrapper>
    </Wrapper>
  );
};
export default AnnounceText;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const ExplainWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 6px;
  background: var(--KTP-Grayscale-Gray_12, #fafafa);
  color: var(--KTP-Grayscale-Gray_05, #777);
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: -0.28px;
  word-break: keep-all;
`;

const ContentsWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 14px;
`;

const Text = styled.p`
  color: var(--KTP-Grayscale-Gray_05, #777);
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: -0.28px;
  word-break: keep-all;
`;

const InquiryButton = styled.button`
  text-decoration: underline;
  font-size: 14px;
  font-weight: 600;
  line-height: 150%;
`;
